import FormApi from "../../services/api/formApi.js";

const FormApiService = new FormApi();

export default {
  data() {
    return {
      model: {
        retailerName: "",
        location: "",
        arrivalDate: "",
        assortmentGoal: "",
        numberOfStyles: "",
        categoryFocus: "",
        volumeOfInventory: "",
        typicalCustomer: "",
        age: "",
        gender: "",
        annualIncome: "",
        typicalFindOut: "",
        kindOfBrands: "",
        topPerformingCategories: "",
        customerGroups: "",
        averageOrderValueStore: "",
        averageOrderValueOnline: "",
        topProductCategories: "",
        lowProductCategories: "",
        popularThemes: "",
        mostExpensivePrice: "",
        leastExpensivePrice: "",
        expletives: "",
        messaging: "",
        celebrity: "",
        cbd: "",
        political: "",
        unwantedCategories: "",
        maximumPricePoint: "",
        minimumPricePoint: "",
        femaleBrands: "",
        notes: "",
      },
    };
  },

  methods: {
    submit: submit,
    resetModel: resetModel,
  },
};

function submit() {
  let _self = this;

  _self.$validator.validate().then((valid) => {
    if (!valid) {
      return false;
    } else {
      var list = document.querySelectorAll("input[name='checkbox_category_focus']:checked"),
        valuesArray = [];

      for (var i = 0; i < list.length; i++) {
        valuesArray.push(list[i].value);
      }

      _self.model.categoryFocus = valuesArray.toString();

      FormApiService.applyAsRetailer(_self.model)
        .then((response) => {
          _self.$swal("Success", "Application submited successfully");
          this.$nextTick(() => this.$validator.reset());
          _self.resetModel();
        })
        .catch((error) => {
          _self.$swal("Alert", "Something went wrong. Please try again later");
        });
    }
  });
}

function resetModel() {
  this.model = {
    retailerName: "",
    location: "",
    arrivalDate: "",
    assortmentGoal: "Test new product categories",
    numberOfStyles: "",
    categoryFocus: "",
    volumeOfInventory: "",
    typicalCustomer: "",
    age: "",
    gender: "",
    annualIncome: "",
    typicalFindOut: "",
    kindOfBrands: "",
    topPerformingCategories: "",
    customerGroups: "",
    averageOrderValueStore: "",
    averageOrderValueOnline: "",
    topProductCategories: "",
    lowProductCategories: "",
    popularThemes: "",
    mostExpensivePrice: "",
    leastExpensivePrice: "",
    expletives: "",
    messaging: "",
    celebrity: "",
    political: "",
    unwantedCategories: "",
    maximumPricePoint: "",
    femaleBrands: "",
    notes: "",
  };
}
